import { useState, type MouseEvent } from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '@/app/router/routes';
import { SidebarBurst, useSidebarBurst } from './SidebarBurst';

const LOGO = '/favicon.png';
const WAVE_LOGO = '/favicon_wave.png';

/**
 * Duplo clique troca o logo entre favicon.png e favicon_wave.png e dispara a explosão.
 * Um clique simples continua navegando para Projetos.
 */
export function SidebarLogo() {
  const [src, setSrc] = useState(LOGO);
  const [bursting, burst] = useSidebarBurst();

  function handleDoubleClick(event: MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
    setSrc((current) => (current === LOGO ? WAVE_LOGO : LOGO));
    burst();
  }

  return (
    <Link
      to={ROUTES.projects}
      onDoubleClick={handleDoubleClick}
      className="flex h-12 w-[44px] items-center justify-center rounded-xl transition-colors hover:bg-white/10"
      title="Projetos"
    >
      <SidebarBurst active={bursting} className="h-12 w-[44px] items-center justify-center">
        <img src={src} alt="Projetos" className="h-12 w-[44px] object-contain" />
      </SidebarBurst>
    </Link>
  );
}
